import { Button } from "antd";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { HomeImage } from "../../../assets";
import { useMediaQuery } from "react-responsive";
import { LanguageContext } from "../../../context/Language.contex";

export const Home = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const navigate = useNavigate();

  // Ambil state bahasa dari Context
  const { language } = useContext(LanguageContext);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row", // Mengatur arah layout berdasarkan mode mobile
        alignItems: "center", // Menyelaraskan item secara vertikal di tengah
        justifyContent: "center", // Menyelaraskan item secara horizontal di tengah
        // marginTop: "1%", // Margin atas untuk memberi ruang
        minHeight: "80vh", // Memastikan div mengisi tinggi layar sepenuhnya
      }}
    >
      {/* Bagian Gambar */}
      <div
        style={{
          flex: 1, // Memberikan fleksibilitas agar gambar menyesuaikan ruang
          textAlign: "center", // Menyelaraskan konten gambar ke tengah
          display: "flex",
          justifyContent: "center", // Menyelaraskan gambar ke tengah secara horizontal
          alignItems: "center", // Menyelaraskan gambar ke tengah secara vertikal
        }}
      >
        <img
          alt="Home Illustration"
          src={HomeImage}
          style={{
            width: isMobile ? "100%" : "100%", // Menyesuaikan lebar gambar berdasarkan mode
            height: isMobile ? "auto" : "auto", // Menyesuaikan tinggi gambar
            objectFit: "cover", // Memastikan gambar tetap proporsional
          }}
        />
      </div>

      {/* Bagian Teks */}
      <div
        style={{
          textAlign: "center", // Menyelaraskan teks ke tengah
          flex: 1, // Memberikan fleksibilitas agar teks menyesuaikan ruang
          marginTop: isMobile ? "20px" : "0", // Memberi jarak antara gambar dan teks di mode mobile
          display: "flex",
          flexDirection: "column", // Mengatur arah teks menjadi kolom
          justifyContent: "center", // Menyelaraskan teks ke tengah secara vertikal
          alignItems: "center", // Menyelaraskan teks ke tengah secara horizontal
        }}
      >
        <span style={{ fontSize: 25, fontWeight: "bold" }}>{language[1]}</span>
        <br />
        <br />
        <span>
          {language[2]}
          <br />
          {language[3]}
        </span>
        <br />
        <br />
        <Button
          style={{
            background: "#1679AB",
            color: "white",
            marginTop: 10,
            height: 40,
            width: 200,
          }}
          onClick={() => {
            navigate("/scan");
          }}
        >
          {language[16]}
        </Button>
      </div>
    </div>
  );
};
